import MainHeader from "../Components/MainHeader";
import { useState, useEffect } from "react";
// import { ReactComponent as SouthMap } from "../Images/map_of_South_Korea.svg";
import SouthMap from "../Components/SouthMap";

const cityList = [
    {
        id: 1,
        address: '서울종로구'
    }, {
        id: 2,
        address: '서울중구'
    }, {
        id: 3,
        address: '서울용산구'
    }, {
        id: 4,
        address: '서울성동구'
    }, {
        id: 5,
        address: '서울광진구'
    }, {
        id: 6,
        address: '서울동대문구'
    }, {
        id: 7,
        address: '서울중랑구'
    }, {
        id: 8,
        address: '서울성북구'
    }, {
        id: 9,
        address: '서울강북구'
    }, {
        id: 10,
        address: '서울도봉구'
    }, {
        id: 11,
        address: '서울노원구'
    }, {
        id: 12,
        address: '서울은평구'
    }, {
        id: 13,
        address: '서울서대문구'
    }, {
        id: 14,
        address: '서울마포구'
    }, {
        id: 15,
        address: '서울양천구'
    }, {
        id: 16,
        address: '서울강서구'
    }, {
        id: 17,
        address: '서울구로구'
    }, {
        id: 18,
        address: '서울금천구'
    }, {
        id: 19,
        address: '서울영등포구'
    }, {
        id: 20,
        address: '서울동작구'
    }, {
        id: 21,
        address: '서울관악구'
    }, {
        id: 22,
        address: '서울서초구'
    }, {
        id: 23,
        address: '서울강남구'
    }, {
        id: 24,
        address: '서울송파구'
    }, {
        id: 25,
        address: '서울강동구'
    }, {
        id: 26,
        address: '부산중구'
    }, {
        id: 27,
        address: '부산서구'
    }, {
        id: 28,
        address: '부산동구'
    }, {
        id: 29,
        address: '부산영도구'
    }, {
        id: 30,
        address: '부산부산진구'
    }, {
        id: 31,
        address: '부산동래구'
    }, {
        id: 32,
        address: '부산남구'
    }, {
        id: 33,
        address: '부산북구'
    }, {
        id: 34,
        address: '부산해운대구'
    }, {
        id: 35,
        address: '부산사하구'
    }, {
        id: 36,
        address: '부산금정구'
    }, {
        id: 37,
        address: '부산강서구'
    }, {
        id: 38,
        address: '부산연제구'
    }, {
        id: 39,
        address: '부산수영구'
    }, {
        id: 40,
        address: '부산사상구'
    }, {
        id: 41,
        address: '부산기장군'
    }, {
        id: 42,
        address: '대구중구'
    }, {
        id: 43,
        address: '대구동구'
    }, {
        id: 44,
        address: '대구서구'
    }, {
        id: 45,
        address: '대구남구'
    }, {
        id: 46,
        address: '대구북구'
    }, {
        id: 47,
        address: '대구수성구'
    }, {
        id: 48,
        address: '대구달서구'
    }, {
        id: 49,
        address: '대구달성군'
    }, {
        id: 50,
        address: '인천중구'
    }, {
        id: 51,
        address: '인천동구'
    }, {
        id: 52,
        address: '인천남구'
    }, {
        id: 53,
        address: '인천연수구'
    }, {
        id: 54,
        address: '인천남동구'
    }, {
        id: 55,
        address: '인천부평구'
    }, {
        id: 56,
        address: '인천계양구'
    }, {
        id: 57,
        address: '인천서구'
    }, {
        id: 58,
        address: '인천강화군'
    }, {
        id: 59,
        address: '인천옹진군'
    }, {
        id: 60,
        address: '광주동구'
    }, {
        id: 61,
        address: '광주서구'
    }, {
        id: 62,
        address: '광주남구'
    }, {
        id: 63,
        address: '광주북구'
    }, {
        id: 64,
        address: '광주광산구'
    }, {
        id: 65,
        address: '대전동구'
    }, {
        id: 66,
        address: '대전중구'
    }, {
        id: 67,
        address: '대전서구'
    }, {
        id: 68,
        address: '대전유성구'
    }, {
        id: 69,
        address: '대전대덕구'
    }, {
        id: 70,
        address: '울산중구'
    }, {
        id: 71,
        address: '울산남구'
    }, {
        id: 72,
        address: '울산동구'
    }, {
        id: 73,
        address: '울산북구'
    }, {
        id: 74,
        address: '울산울주군'
    }, {
        id: 75,
        address: '세종특별자치시'
    }, {
        id: 76,
        address: '수원시장안구'
    }, {
        id: 77,
        address: '수원시권선구'
    }, {
        id: 78,
        address: '수원시팔달구'
    }, {
        id: 79,
        address: '수원시영통구'
    }, {
        id: 80,
        address: '성남시수정구'
    }, {
        id: 81,
        address: '성남시중원구'
    }, {
        id: 82,
        address: '성남시분당구'
    }, {
        id: 83,
        address: '경기의정부시'
    }, {
        id: 84,
        address: '안양시만안구'
    }, {
        id: 85,
        address: '안양시동안구'
    }, {
        id: 86,
        address: '경기부천시'
    }, {
        id: 87,
        address: '경기광명시'
    }, {
        id: 88,
        address: '경기평택시'
    }, {
        id: 89,
        address: '경기동두천시'
    }, {
        id: 90,
        address: '안산시상록구'
    }, {
        id: 91,
        address: '안산시단원구'
    }, {
        id: 92,
        address: '고양시덕양구'
    }, {
        id: 93,
        address: '고양시일산동구'
    }, {
        id: 94,
        address: '고양시일산서구'
    }, {
        id: 95,
        address: '경기과천시'
    }, {
        id: 96,
        address: '경기구리시'
    }, {
        id: 97,
        address: '경기남양주시'
    }, {
        id: 98,
        address: '경기오산시'
    }, {
        id: 99,
        address: '경기시흥시'
    }, {
        id: 100,
        address: '경기군포시'
    }, {
        id: 101,
        address: '경기의왕시'
    }, {
        id: 102,
        address: '경기하남시'
    }, {
        id: 103,
        address: '용인시처인구'
    }, {
        id: 104,
        address: '용인시기흥구'
    }, {
        id: 105,
        address: '용인시수지구'
    }, {
        id: 106,
        address: '경기파주시'
    }, {
        id: 107,
        address: '경기이천시'
    }, {
        id: 108,
        address: '경기안성시'
    }, {
        id: 109,
        address: '경기김포시'
    }, {
        id: 110,
        address: '경기화성시'
    }, {
        id: 111,
        address: '경기광주시'
    }, {
        id: 112,
        address: '경기양주시'
    }, {
        id: 113,
        address: '경기포천시'
    }, {
        id: 114,
        address: '경기여주시'
    }, {
        id: 115,
        address: '경기연천군'
    }, {
        id: 116,
        address: '경기가평군'
    }, {
        id: 117,
        address: '경기양평군'
    }, {
        id: 118,
        address: '강원특별자치도춘천시'
    }, {
        id: 119,
        address: '강원특별자치도원주시'
    }, {
        id: 120,
        address: '강원특별자치도강릉시'
    }, {
        id: 121,
        address: '강원특별자치도동해시'
    }, {
        id: 122,
        address: '강원특별자치도태백시'
    }, {
        id: 123,
        address: '강원특별자치도속초시'
    }, {
        id: 124,
        address: '강원특별자치도삼척시'
    }, {
        id: 125,
        address: '강원특별자치도홍천군'
    }, {
        id: 126,
        address: '강원특별자치도횡성군'
    }, {
        id: 127,
        address: '강원특별자치도영월군'
    }, {
        id: 128,
        address: '강원특별자치도평창군'
    }, {
        id: 129,
        address: '강원특별자치도정선군'
    }, {
        id: 130,
        address: '강원특별자치도철원군'
    }, {
        id: 131,
        address: '강원특별자치도화천군'
    }, {
        id: 132,
        address: '강원특별자치도양구군'
    }, {
        id: 133,
        address: '강원특별자치도인제군'
    }, {
        id: 134,
        address: '강원특별자치도고성군'
    }, {
        id: 135,
        address: '강원특별자치도양양군'
    }, {
        id: 136,
        address: '청주시상당구'
    }, {
        id: 137,
        address: '청주시서원구'
    }, {
        id: 138,
        address: '청주시흥덕구'
    }, {
        id: 139,
        address: '청주시청원구'
    }, {
        id: 140,
        address: '충청충주시'
    }, {
        id: 141,
        address: '충청제천시'
    }, {
        id: 142,
        address: '충청보은군'
    }, {
        id: 143,
        address: '충청옥천군'
    }, {
        id: 144,
        address: '충청영동군'
    }, {
        id: 145,
        address: '충청증평군'
    }, {
        id: 146,
        address: '충청진천군'
    }, {
        id: 147,
        address: '충청괴산군'
    }, {
        id: 148,
        address: '충청음성군'
    }, {
        id: 149,
        address: '충청단양군'
    }, {
        id: 150,
        address: '천안시동남구'
    }, {
        id: 151,
        address: '천안시서북구'
    }, {
        id: 152,
        address: '충청공주시'
    }, {
        id: 153,
        address: '충청보령시'
    }, {
        id: 154,
        address: '충청아산시'
    }, {
        id: 155,
        address: '충청서산시'
    }, {
        id: 156,
        address: '충청논산시'
    }, {
        id: 157,
        address: '충청계룡시'
    }, {
        id: 158,
        address: '충청당진시'
    }, {
        id: 159,
        address: '충청금산군'
    }, {
        id: 160,
        address: '충청부여군'
    }, {
        id: 161,
        address: '충청서천군'
    }, {
        id: 162,
        address: '충청청양군'
    }, {
        id: 163,
        address: '충청홍성군'
    }, {
        id: 164,
        address: '충청예산군'
    }, {
        id: 165,
        address: '충청태안군'
    }, {
        id: 166,
        address: '전주시완산구'
    }, {
        id: 167,
        address: '전주시덕진구'
    }, {
        id: 168,
        address: '전라군산시'
    }, {
        id: 169,
        address: '전라익산시'
    }, {
        id: 170,
        address: '전라정읍시'
    }, {
        id: 171,
        address: '전라남원시'
    }, {
        id: 172,
        address: '전라김제시'
    }, {
        id: 173,
        address: '전라완주군'
    }, {
        id: 174,
        address: '전라진안군'
    }, {
        id: 175,
        address: '전라무주군'
    }, {
        id: 176,
        address: '전라장수군'
    }, {
        id: 177,
        address: '전라임실군'
    }, {
        id: 178,
        address: '전라순창군'
    }, {
        id: 179,
        address: '전라고창군'
    }, {
        id: 180,
        address: '전라부안군'
    }, {
        id: 181,
        address: '전라목포시'
    }, {
        id: 182,
        address: '전라여수시'
    }, {
        id: 183,
        address: '전라순천시'
    }, {
        id: 184,
        address: '전라나주시'
    }, {
        id: 185,
        address: '전라광양시'
    }, {
        id: 186,
        address: '전라담양군'
    }, {
        id: 187,
        address: '전라곡성군'
    }, {
        id: 188,
        address: '전라구례군'
    }, {
        id: 189,
        address: '전라고흥군'
    }, {
        id: 190,
        address: '전라보성군'
    }, {
        id: 191,
        address: '전라화순군'
    }, {
        id: 192,
        address: '전라장흥군'
    }, {
        id: 193,
        address: '전라강진군'
    }, {
        id: 194,
        address: '전라해남군'
    }, {
        id: 195,
        address: '전라영암군'
    }, {
        id: 196,
        address: '전라무안군'
    }, {
        id: 197,
        address: '전라함평군'
    }, {
        id: 198,
        address: '전라영광군'
    }, {
        id: 199,
        address: '전라장성군'
    }, {
        id: 200,
        address: '전라완도군'
    }, {
        id: 201,
        address: '전라진도군'
    }, {
        id: 202,
        address: '전라신안군'
    }, {
        id: 203,
        address: '포항시남구'
    }, {
        id: 204,
        address: '포항시북구'
    }, {
        id: 205,
        address: '경상경주시'
    }, {
        id: 206,
        address: '경상김천시'
    }, {
        id: 207,
        address: '경상안동시'
    }, {
        id: 208,
        address: '경상구미시'
    }, {
        id: 209,
        address: '경상영주시'
    }, {
        id: 210,
        address: '경상영천시'
    }, {
        id: 211,
        address: '경상상주시'
    }, {
        id: 212,
        address: '경상문경시'
    }, {
        id: 213,
        address: '경상경산시'
    }, {
        id: 214,
        address: '경상군위군'
    }, {
        id: 215,
        address: '경상의성군'
    }, {
        id: 216,
        address: '경상청송군'
    }, {
        id: 217,
        address: '경상영양군'
    }, {
        id: 218,
        address: '경상영덕군'
    }, {
        id: 219,
        address: '경상청도군'
    }, {
        id: 220,
        address: '경상고령군'
    }, {
        id: 221,
        address: '경상성주군'
    }, {
        id: 222,
        address: '경상칠곡군'
    }, {
        id: 223,
        address: '경상예천군'
    }, {
        id: 224,
        address: '경상봉화군'
    }, {
        id: 225,
        address: '경상울진군'
    }, {
        id: 226,
        address: '경상울릉군'
    }, {
        id: 227,
        address: '창원시의창구'
    }, {
        id: 228,
        address: '창원시성산구'
    }, {
        id: 229,
        address: '창원시마산합포구'
    }, {
        id: 230,
        address: '창원시마산회원구'
    }, {
        id: 231,
        address: '창원시진해구'
    }, {
        id: 232,
        address: '경상진주시'
    }, {
        id: 233,
        address: '경상통영시'
    }, {
        id: 234,
        address: '경상사천시'
    }, {
        id: 235,
        address: '경상김해시'
    }, {
        id: 236,
        address: '경상밀양시'
    }, {
        id: 237,
        address: '경상거제시'
    }, {
        id: 238,
        address: '경상양산시'
    }, {
        id: 239,
        address: '경상의령군'
    }, {
        id: 240,
        address: '경상함안군'
    }, {
        id: 241,
        address: '경상창녕군'
    }, {
        id: 242,
        address: '경상고성군'
    }, {
        id: 243,
        address: '경상남해군'
    }, {
        id: 244,
        address: '경상하동군'
    }, {
        id: 245,
        address: '경상산청군'
    }, {
        id: 246,
        address: '경상함양군'
    }, {
        id: 247,
        address: '경상거창군'
    }, {
        id: 248,
        address: '경상합천군'
    }, {
        id: 249,
        address: '제주특별자치도제주시'
    }, {
        id: 250,
        address: '제주특별자치도서귀포시'
    }]

const locationCheck = () => {
}

const LocationMap = () => {

    const [Total, setTotal] = useState(0);
    const [location, setLocation] = useState(null);
    const [position, setPosition] = useState("");
    const [percentage, setPercentage] = useState("");
    const [procsesing, setProcessing] = useState("");

    const userData = JSON.parse(sessionStorage.getItem("UserData"));
  
    useEffect(() => {
      if (!userData?.location || !userData.locationComplete) {
        fetch(process.env.REACT_APP_API_ADDRESS + `/getLocation?id=${userData?.id}`)
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            if (data.result === null) {
                if(data.status){  //큐에 존재한다면 
                    setProcessing(false);
                    setPosition(data.position);
                    setPercentage((100 - data.percentage).toFixed(2));
                } else{ //큐에 존재하지 않는다면 즉, 프로세싱 중이라면
                    setProcessing(true);
                }
            } else {
              setLocation(data.result);
            }
          })
          .catch((error) => {
            console.error("Error fetching location data:", error);
          });
      } else {
        setLocation(userData.location);
      }
    }, []);
  
    const parentFunction = (x) => {};
  
    return (
      <div>
        <MainHeader parentFunction={parentFunction} />
        <div className="Map">
          {location !== null && location.length > 0 ? (
            <SouthMap location={location} />
          ) : (
            <p style={{ whiteSpace: "pre-line", fontSize: '2vw' }}>
            {!procsesing ? (
              `카카오 Local API의 일일 요청 횟수가 초과되어 사용자님의 데이터는 처리되던 도중 중단되었습니다.\n매일 00시 00분에 요청 가능수가 초기화되며 현재 대기중에 있습니다.\n\n사용자님의 데이터는 ${position + 1}번째 순서로 대기중이며 현재까지 ${percentage} % 완료되었습니다.`
            ) : (
              "아직 데이터 처리가 완료되지 않았습니다. 라이딩 좌표마다 API요청을 해야되서 쫌 오래걸립니다. \n현재 처리중이니 약 5분뒤에 다시 시도해보세요.\n가능하면 실시간 진행상황 추적 기능도 넣어볼게요"
            )}
          </p>
          )}
        </div>
      </div>
    );
  };
  




// const LocationMap = () => {
//     const [Total, setTotal] = useState(0);
//     const userData = JSON.parse(sessionStorage.getItem("UserData"));
//     const location = userData?.location;
  
    
//     return (
//         <div>
//           <MainHeader parentFunction={parentFunction} />
//           <div className="Map">
//             {location !== null && location.length > 0 ? (
//               <SouthMap location={location} />
//             ) : (
//               <p>아직 데이터 처리가 완료되지 않았습니다.</p>
//             )}
//           </div>
//         </div>
//       );
//     };
  
export default LocationMap